import moment from 'moment';

export const convertDate = (value: moment.MomentInput) => {

  if (value) {
    return moment(value).format('DD.MM.YYYY');
  } else {
    return null;
  }
};
